<template>
    <v-container fluid>
        <v-btn
            :loading="accountsWithInfo === null"
            @click="newAccount"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                sm="8"
            >
                <v-subheader>
                    <h2>Accounts ({{ totalMatches }})</h2>
                </v-subheader>
                <!--<v-subheader>
                    <h5>
                        Accounts excluded: Accepted, Rejected
                        <br />Adjust filter for inclusion
                    </h5>
                </v-subheader>-->
            </v-col>
            <!--<v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>-->
            <v-col
                class="text-right"
                cols="12"
                sm="4"
            >
                <v-btn
                    @click="showMultiSearch = !showMultiSearch"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon v-if="anyMultiSearchInput">mdi-card-search</v-icon>
                    <v-icon v-else>mdi-card-search-outline</v-icon>
                </v-btn>

                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="accountsWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="accountWithInfo.entity.id"
                    cols="12"
                    v-for="accountWithInfo in accountsWithInfo"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                    >
                        <v-card
                        flat
                        @click="loadAccountForm(accountWithInfo.entity)"
                        >
                        <v-card-title
                        >#{{ accountWithInfo.entity.id }}</v-card-title>
                        <!--<v-card-subtitle>
                            GRV Number:
                            {{ accountWithInfo.entity.grvNumber }}
                        </v-card-subtitle>-->
                        <v-card-text>
                            <v-row no-gutters>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >Invoice Number:{{ accountWithInfo.entity.invoiceNumber }}
                            </v-chip>                                
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-doctor</v-icon>
                                {{
                                getProviderName(
                                accountWithInfo.entity.providerId
                                )
                                }}
                            </v-chip>                           
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="accountWithInfo.entity.createdByUser"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-plus-thick</v-icon>
                                {{ accountWithInfo.entity.createdByUser }}
                                <!--
                                {{ accountWithInfo.entity.createdByUser.name }}
                                {{
                                accountWithInfo.entity.createdByUser.surname
                                }}
                                -->
                            </v-chip>   
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                {{
                                getAccountStatusName(
                                accountWithInfo.entity.accountStatus
                                )
                                }}
                            </v-chip> 
                            <v-chip                                
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                Total Face Value:
                                {{
                                accountWithInfo.entity.serviceProviderTotalFaceValue.toFixed(2)
                                }}
                            </v-chip>                    
                        </v-row>
                        <v-row v-show="accountWithInfo.entity.hasPrefundFunding" no-gutters>
                            <v-chip
                                class="ma-1"
                                color="secondary lighten-1"
                                dark
                                small
                            >Prefund</v-chip>
                            <v-chip                                
                                class="ma-1"
                                color="secondary lighten-1"
                                dark
                                small
                            >
                                Prefund Face Value:
                                {{
                                accountWithInfo.entity.faceValuePrefund.toFixed(2)
                                }}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary lighten-1"
                                dark
                                small
                            >
                                Prefund Purchase Value:
                                {{
                                accountWithInfo.entity.purchaseValuePrefund.toFixed(2)
                                }}
                            </v-chip>
                        </v-row>
                        <v-row v-show="accountWithInfo.entity.hasAdminFunding" no-gutters>
                            <v-chip
                                class="ma-1"
                                color="secondary darken-1"
                                dark
                                small
                            >Administered</v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary darken-1"
                                dark
                                small
                            >
                                Administered Face Value:
                                {{
                                accountWithInfo.entity.faceValueAdmin.toFixed(2)
                                }}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary darken-1"
                                dark
                                small
                            >
                                Administered Purchase Value:
                                {{
                                accountWithInfo.entity.purchaseValueAdmin.toFixed(2)
                                }}
                            </v-chip>
                        </v-row>
                        </v-card-text>
                        </v-card>
                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Created
                                            <br />
                                            <h3>
                                                {{
                                                dateToString(
                                                accountWithInfo.entity
                                                .createdAt
                                                )
                                                }}
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Processed
                                            <br />
                                            <h3>
                                                <span
                                                    v-if="
                                                        accountWithInfo.entity
                                                            .processedAt
                                                    "
                                                >
                                                    {{
                                                    dateToString(
                                                    accountWithInfo
                                                    .entity
                                                    .processedAt
                                                    )
                                                    }}
                                                </span>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Accepted
                                            <br />
                                            <h3>
                                                <span
                                                    v-if="
                                                        accountWithInfo.entity
                                                            .acceptedAt
                                                    "
                                                >
                                                    {{
                                                    dateToString(
                                                    accountWithInfo
                                                    .entity
                                                    .acceptedAt
                                                    )
                                                    }}
                                                </span>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Final Acc.
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        accountWithInfo.entity
                                                            .isFinalAccount
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card class="pa-1 ma-1 fill-height">
                                            Paid
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="
                                                        accountWithInfo.entity
                                                            .isPaid
                                                    "
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </div>

                        <v-expansion-panels v-if="accountWithInfo.entity.patient">
                            <v-expansion-panel
                                @click.stop="() => ({})"
                                class="patient-panel"
                            >
                                <v-expansion-panel-header>
                                    <!--@click.stop="testf"-->
                                    <v-row justify="start">
                                        <v-col
                                            cols="6"
                                            md="2"
                                        >
                                            <div style="display: inline-block">
                                                <strong>
                                                    {{
                                                    accountWithInfo.entity
                                                    .patient.identity
                                                    .name
                                                    }}
                                                    {{
                                                    accountWithInfo.entity
                                                    .patient.identity
                                                    .surname
                                                    }}
                                                </strong>
                                                <v-card-subtitle
                                                    class="ma-0 pa-0"
                                                    v-if="accountWithInfo.entity.patient.mediKreditAddCardId > 0"
                                                >
                                                    <strong>Member Id: {{accountWithInfo.entity.patient.id}}</strong>
                                                </v-card-subtitle>
                                            </div>

                                            <v-chip
                                                class="ma-1"
                                                color="secondary"
                                                dark
                                                small
                                                v-show="
                                                    accountWithInfo.entity
                                                        .patient.identity
                                                        .verifiedRsaIdId > 0
                                                "
                                            >Verified RSA ID</v-chip>

                                            <v-chip
                                                class="ma-1"
                                                color="warning"
                                                dark
                                                small
                                                v-show="
                                                    accountWithInfo.entity
                                                        .patient.identity
                                                        .deceased
                                                "
                                            >Deceased</v-chip>
                                        </v-col>
                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                @click.stop="
                                                    if (
                                                        accountWithInfo.entity
                                                            .patient
                                                            .consentFormFileId >
                                                        0
                                                    )
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .consentFormFileId,
                                                                namePrefix:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .id +
                                                                    '_ConsentForm',
                                                            }
                                                        );
                                                "
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Consent Form
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .consentFormFileId
                                                        "
                                                    >mdi-check</v-icon>
                                                    <v-icon
                                                        color="info"
                                                        v-else-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .consentFormAvailable
                                                        "
                                                    >mdi-alpha-a-circle</v-icon>
                                                    <v-icon
                                                        color="error"
                                                        v-else
                                                    >mdi-close</v-icon>
                                                </h3>
                                            </v-card>
                                        </v-col>
                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                @click.stop="
                                                    if (
                                                        accountWithInfo.entity
                                                            .patient
                                                            .ambulanceReportFileId >
                                                        0
                                                    )
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .ambulanceReportFileId,
                                                                namePrefix:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .id +
                                                                    '_AmbulanceReport',
                                                            }
                                                        );
                                                "
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Amb Report
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .ambulanceReportFileId
                                                        "
                                                    >mdi-check</v-icon>
                                                    <v-icon
                                                        color="info"
                                                        v-else-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .ambulanceReportAvailable
                                                        "
                                                    >mdi-alpha-a-circle</v-icon>
                                                    <v-icon
                                                        color="error"
                                                        v-else
                                                    >mdi-close</v-icon>
                                                </h3>
                                            </v-card>
                                        </v-col>
                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                @click.stop="
                                                    if (
                                                        accountWithInfo.entity
                                                            .patient
                                                            .transferLetterFileId >
                                                        0
                                                    )
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .transferLetterFileId,
                                                                namePrefix:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .id +
                                                                    '_TransferLetter',
                                                            }
                                                        );
                                                "
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Transfer Let
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .transferLetterFileId
                                                        "
                                                    >mdi-check</v-icon>
                                                    <v-icon
                                                        color="info"
                                                        v-else-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .transferLetterAvailable
                                                        "
                                                    >mdi-alpha-a-circle</v-icon>
                                                    <v-icon
                                                        color="error"
                                                        v-else
                                                    >mdi-close</v-icon>
                                                </h3>
                                            </v-card>
                                        </v-col>
                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                @click.stop="
                                                    if (
                                                        accountWithInfo.entity
                                                            .patient.identity
                                                            .idDocumentFileId >
                                                        0
                                                    )
                                                        $store.dispatch(
                                                            'files/get',
                                                            {
                                                                fileId:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .identity
                                                                        .idDocumentFileId,
                                                                namePrefix:
                                                                    accountWithInfo
                                                                        .entity
                                                                        .patient
                                                                        .identity
                                                                        .id +
                                                                    '_Identity',
                                                            }
                                                        );
                                                "
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                ID Doc
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .identity
                                                                .idDocumentFileId
                                                        "
                                                    >mdi-check</v-icon>
                                                    <v-icon
                                                        color="info"
                                                        v-else-if="
                                                            accountWithInfo
                                                                .entity.patient
                                                                .identity
                                                                .idDocumentAvailable
                                                        "
                                                    >mdi-alpha-a-circle</v-icon>
                                                    <v-icon
                                                        color="error"
                                                        v-else
                                                    >mdi-close</v-icon>
                                                </h3>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <span v-if="identityTypes">
                                        Id Type:
                                        <strong>
                                            {{
                                            identityTypes.find(
                                            (x) =>
                                            x.key ==
                                            accountWithInfo.entity
                                            .patient.identity
                                            .identityTypeId
                                            ).value
                                            }}
                                        </strong>
                                    </span>
                                    <br />Id Number:
                                    <strong>
                                        {{
                                        accountWithInfo.entity.patient
                                        .identity.identificationNumber
                                        }}
                                    </strong>
                                    <br />
                                    <v-btn
                                        @click.stop="
                                            locatedPatient(
                                                accountWithInfo.entity.patient
                                            )
                                        "
                                        class="text-none float-right"
                                        color="secondary darken-1"
                                    >View Accounts</v-btn>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!--EDIT/NEW FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="accountFormVisible"
        >
            <v-sheet
                class="base-background"
                min-height="100%"
            >
                <v-toolbar
                    color="secondary darken-1"
                    dark
                >
                    <v-btn
                        @click="closeAccountForm"
                        dark
                        icon
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Account Details</v-toolbar-title>

                    <v-btn
                        @click.stop="newSamePatientAccount"
                        class="ml-3"
                        dark
                        icon
                        small
                        v-show="this.accountFormKey > 0"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row
                        align="center"
                        justify="center"
                        v-if="true"
                    >
                        <AccountForm
                            :account-in="accountFormAccount"
                            :disciplines="accountDisciplines"
                            :key="accountFormKey"
                            @close="closeAccountForm"
                            @deleted="deleteAccount"
                            @saved="updateAccount"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>
        <!--MultiSeardch SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            v-model="showMultiSearch"
            width="350px"
        >
            <multi-search-input-form
                :fields="multiSearchFields"
                @close="showMultiSearch = false"
                @reset="multiSearch"
                @search="multiSearch"
            />
        </v-dialog>
        <!--FILTER SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Account Filtering</v-card-title>
                <v-card-text>
                    <v-select
                        :items="providers"
                        @change="
                            () => {
                                pageNo = 1;
                                paginationDebounce(filterDebounceTime);
                            }
                        "
                        class="my-0"
                        clearable
                        item-text="value"
                        item-value="key"
                        label="Provider"
                        v-model="filterProviderId"
                    ></v-select>
                    <v-select
                        :items="accountStatuses"
                        @change="
                            () => {
                                pageNo = 1;
                                paginationDebounce(filterDebounceTime);
                            }
                        "
                        class="my-0"
                        clearable
                        item-text="value"
                        item-value="key"
                        label="Account Status"
                        v-model="filterAccountStatus"
                    ></v-select>

                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Is Paid"
                        v-model="filterCheckIsPaid"
                    ></v-switch>
                    <v-radio-group
                        :column="false"
                        :disabled="!filterCheckIsPaid"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        v-model="filterIsPaid"
                    >
                        <v-radio
                            :value="true"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            :value="false"
                            class="ml-5"
                            label="No"
                        ></v-radio>
                    </v-radio-group>

                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="In Claim"
                        v-model="filterCheckInClaim"
                    ></v-switch>
                    <v-radio-group
                        :column="false"
                        :disabled="!filterCheckInClaim"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        v-model="filterInClaim"
                    >
                        <v-radio
                            :value="true"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            :value="false"
                            class="ml-5"
                            label="No"
                        ></v-radio>
                    </v-radio-group>

                    <v-divider></v-divider>
                    <!--<v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Ageing days"
                        v-model="filterOnAgeing"
                    ></v-switch>
                    <v-select
                        :disabled="!filterOnAgeing"
                        :items="ageingOptions"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        item-text="name"
                        item-value="value"
                        style="max-width: 200px"
                        v-model="filterAgeing"
                    ></v-select>
                    -->

                    <!--
                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Has Driving License"
                        v-model="filterDrivingLicense"
                    ></v-switch>
                    <v-radio-group
                        :column="false"
                        :disabled="!filterDrivingLicense"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        v-model="filterHasDrivingLicense"
                    >
                        <v-radio
                            :value="true"
                            label="Yes"
                        ></v-radio>
                        <v-radio
                            :value="false"
                            class="ml-5"
                            label="No"
                        ></v-radio>
                    </v-radio-group>
                    -->

                    <v-divider class="mt-3 mb-8"></v-divider>
                    <!-- patient filter start-->
                    <v-btn
                        @click="loadPatientFindForm"
                        class="text-none"
                        color="light-blue darken-1"
                        dark
                        v-if="filterPatient === null"
                    >
                        <v-icon
                            dark
                            left
                        >mdi-account</v-icon>Specify Patient
                    </v-btn>
                    <v-btn
                        @click="clearPatientFindForm"
                        class="text-none"
                        color="light-blue darken-1"
                        text
                        v-else
                    >
                        <v-icon
                            dark
                            left
                        >mdi-close</v-icon>Clear Patient
                    </v-btn>
                    <v-card v-if="filterPatient">
                        <v-card-text>
                            Incident #{{ filterPatient.incidentId }}
                            <br />
                            {{ filterPatient.identity.name }}
                            {{ filterPatient.identity.surname }}
                            <br />
                            <span v-if="identityTypes">
                                {{
                                identityTypes.find(
                                (x) =>
                                x.key ==
                                filterPatient.identity
                                .identityTypeId
                                )
                                ? identityTypes.find(
                                (x) =>
                                x.key ==
                                filterPatient.identity
                                .identityTypeId
                                ).value
                                : ""
                                }}
                            </span>
                            :
                            {{ filterPatient.identity.identificationNumber }}
                        </v-card-text>
                    </v-card>
                    <!-- patient filter end-->
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
            <v-dialog
                persistent
                v-model="patientFindFormVisible"
                width="500px"
            >
                <PatientFindForm
                    :key="patientFindFormKey"
                    @close="closePatientFindForm"
                    @located="locatedPatient"
                />
            </v-dialog>
        </v-dialog>

        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import AccountForm from "../components/forms/AccountForm";
import PatientFindForm from "../components/forms/PatientFindForm";
import dateToString from "../helpers/dateToString";
import Account from "../models/Account.model";
import Patient from "../models/Patient.model";
import uuid4 from "../helpers/uuid4";
import MultiSearchInputForm from "../components/forms/MultiSearchInputForm";
//import numberhelpers from "../helpers/numberHelpers"

export default {
    name: "Accounts",
    props: [
        "providerId",
        "areaId",
        "patientId",
        "accountStatus",
        "accountId",
        "isPaid",
        "inClaim",
        "agedDaysMin",
        "agedDaysMax",
        "hasFinalAccount",
        "claimHasPodFile",
        "inDayBatch",
        "notReadyToBePrinted",
        "agedDaysMinByAcceptedAt",
        "agedDaysMaxByAcceptedAt",
        "agedDaysMinByVerifiedAt",
        "agedDaysMaxByVerifiedAt",
        "agedDaysMinByProcessedAt",
        "agedDaysMaxByProcessedAt",
        "agedDaysMinByQueriedAt",
        "agedDaysMaxByQueriedAt",
        "claimId",
        "agedDaysMinByRejectedAt",
        "agedDaysMaxByRejectedAt"
    ],
    //mixins:[numberhelpers],
    data: function() {
        return {
            //main data
            accountsWithInfo: null,
            accountDisciplines: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,

            //form data
            accountFormVisible: false,
            accountFormKey: 0,
            accountFormAccount: new Account(),

            identityTypes: [],
            providers: [],
            accountStatuses: [],
            fundingTypes: [],

            //filters
            showFilters: false,
            filterDebounceTime: 500,
            filterProviderId: this.providerId > 0 ? this.providerId : null,
            filterAreaId: this.areaId > 0 ? this.areaId : null,
            filterAccountId: this.accountId > 0 ? this.accountId : null,
            filterPatient: null,
            filterAccountStatus:
                this.accountStatus > 0 ? this.accountStatus : null,

            filterCheckIsPaid: this.isPaid !== undefined,
            filterIsPaid: !!this.isPaid,

            filterCheckInClaim: this.inClaim !== undefined,
            filterInClaim: !!this.inClaim,

            patientFindFormVisible: false,
            patientFindFormKey: 0,
            filterOnAgeing: this.ageing !== undefined,
            //filterAgeing: isNaN(this.ageing) ? 0 : parseInt(this.ageing),

            showMultiSearch: false,
            multiSearchFields: [
                { display: "Account #", property: "accountId" },
                { display: "Provider Name", property: "providerName" },
                { display: "Patient Name", property: "patientName" },
                { display: "Patient Surname", property: "patientSurname" },
                {
                    display: "Patient Identity Number",
                    property: "patientIdentityNumber"
                },
                { display: "Grv Number", property: "grvNumber" },
                { display: "Invoice Number", property: "invoiceNumber" }
            ],
            multiSearchValues: []

            //
        };
    },
    mounted: async function() {
        this.accountDisciplines = await this.$store.dispatch("disciplines/get");
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.providers = await this.$store.dispatch("providers/getlist");
        this.fundingTypes = await this.$store.dispatch(
            "accounts/getFundingTypes"
        );
        this.accountStatuses = await this.$store.dispatch(
            "accounts/getStatuses"
        );
        if (this.patientId > 0) {
            var patientWithInfo = await this.$store.dispatch(
                "patients/getOne",
                this.patientId
            );
            if (patientWithInfo) this.filterPatient = patientWithInfo.entity;
        }

        this.getAccounts();
    },
    components: {
        AccountForm,
        PatientFindForm,
        MultiSearchInputForm
        //
    },
    computed: {
        anyMultiSearchInput: function() {
            return this.multiSearchValues.some(
                x => x.value != "" && x.value != null
            );
        }
        //
    },
    methods: {
        multiSearch(values) {
            this.multiSearchValues = values;
            this.searchString = "";
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(0);
        },
        async getAccounts() {
            var requestId = (this.requestId = uuid4());

            var urlParameters = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                searchString: this.searchString,
                orderBy: this.orderBy,
                sortOrder: this.sortOrder,
                providerId: this.filterProviderId
                    ? this.filterProviderId
                    : null,
                areaId: this.filterAreaId ? this.filterAreaId : null,
                patientId: this.filterPatient ? this.filterPatient.id : null,
                accountStatus: this.filterAccountStatus
                    ? this.filterAccountStatus
                    : null,
                isPaid: this.filterCheckIsPaid ? this.filterIsPaid : null,
                inClaim: this.filterCheckInClaim ? this.filterInClaim : null,
                //NEW ONES TO BE ADDED TO FILTER GUI AND FILTER RESET
                agedDaysMin: this.agedDaysMin ? this.agedDaysMin : null,
                agedDaysMax: this.agedDaysMax ? this.agedDaysMax : null,
                hasFinalAccount:
                    this.hasFinalAccount !== undefined
                        ? this.hasFinalAccount
                        : null,
                claimHasPodFile:
                    this.claimHasPodFile !== undefined
                        ? this.claimHasPodFile
                        : null,
                inDayBatch:
                    this.inDayBatch !== undefined
                        ? this.inDayBatch
                        : null,
                notReadyToBePrinted:
                    this.notReadyToBePrinted !== undefined
                        ? this.notReadyToBePrinted
                        : null,
                agedDaysMinByAcceptedAt: this.agedDaysMinByAcceptedAt ? this.agedDaysMinByAcceptedAt : null,
                agedDaysMaxByAcceptedAt: this.agedDaysMaxByAcceptedAt ? this.agedDaysMaxByAcceptedAt : null,
                agedDaysMinByVerifiedAt: this.agedDaysMinByVerifiedAt ? this.agedDaysMinByVerifiedAt : null,
                agedDaysMaxByVerifiedAt: this.agedDaysMaxByVerifiedAt ? this.agedDaysMaxByVerifiedAt : null,
                agedDaysMinByProcessedAt: this.agedDaysMinByProcessedAt ? this.agedDaysMinByProcessedAt : null,
                agedDaysMaxByProcessedAt: this.agedDaysMaxByProcessedAt ? this.agedDaysMaxByProcessedAt : null,
                agedDaysMinByQueriedAt: this.agedDaysMinByQueriedAt ? this.agedDaysMinByQueriedAt : null,
                agedDaysMaxByQueriedAt: this.agedDaysMaxByQueriedAt ? this.agedDaysMaxByQueriedAt : null,
                claimId: this.claimId ? this.claimId : null,
                agedDaysMinByRejectedAt: this.agedDaysMinByRejectedAt ? this.agedDaysMinByRejectedAt : null,
                agedDaysMaxByRejectedAt: this.agedDaysMaxByRejectedAt ? this.agedDaysMaxByRejectedAt : null,
            };

            this.multiSearchValues
                .filter(x => x.value != "" && x.value != null)
                .forEach(x => (urlParameters[x.property] = x.value));

            var accountsResponse = await this.$store.dispatch("accounts/get", {
                id: this.filterAccountId,
                urlParameters,
                requestId: requestId
            });

            if (this.requestId == accountsResponse.requestId) {
                //accountsResponse.data.page.forEach(x =>this.accountApplyDisciplineName(x.entity));
                this.accountsWithInfo = accountsResponse.data.page;
                this.totalMatches = accountsResponse.data.total;
                this.pagesCount = Math.ceil(
                    accountsResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.accountsWithInfo !== null) this.accountsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(this.getAccounts, debounceTime);
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterAccountId = null;
            this.filterProviderId = null;
            this.filterPatient = null;
            this.filterCheckIsPaid = null;
            this.filterCheckInClaim = null;
            this.filterOnAgeing = null;
            this.filterAccountStatus = null;
            this.paginationDebounce(0);
        },
        /*
        accountApplyDisciplineName(account) {
            account.disciplineName = this.accountDisciplines.find(
                y => y.id == account.disciplineId
            ).name;
        },*/
        newAccount() {
            var account = new Account();
            account.id = 0;
            account.accountStatus = 1;
            account.fundingTypeOverride = 0;
            this.loadAccountForm(account);
        },
        newSamePatientAccount() {
            var currentAccount = this.accountsWithInfo.find(
                x => x.entity.id == this.accountFormKey
            );
            var newAccount = new Account();
            newAccount.id = 0;
            newAccount.accountStatus = 1;
            newAccount.fundingTypeOverride = 0;
            newAccount.providerId = currentAccount.entity.providerId;
            newAccount.patientId = currentAccount.entity.patientId;
            newAccount.patient = new Patient().set(
                currentAccount.entity.patient
            );
            this.closeAccountForm();
            this.loadAccountForm(newAccount);
        },
        loadAccountForm(account) {
            this.accountFormAccount = new Account().set(account);
            this.accountFormKey = account.id;
            this.accountFormVisible = true;
        },
        closeAccountForm() {
            this.accountFormVisible = false;
            this.accountFormAccount = new Account();
            this.accountFormKey = null;
            this.paginationDebounce(0);
        },
        updateAccount() {
            this.paginationDebounce(0);
            /*
            this.accountApplyDisciplineName(accountWithInfo.entity);
            var updateIndex = this.accountsWithInfo.findIndex(
                x => x.entity.id == accountWithInfo.entity.id
            );
            if (updateIndex > -1)
                this.$set(
                    this.accountsWithInfo,
                    updateIndex,
                    accountWithInfo
                );
            else if (updateIndex == -1) this.getAccounts();
            */
            //this.accountsWithInfo.push(accountWithInfo);
        },
        deleteAccount() {
            this.paginationDebounce(0);
            /*
            var deletedIndex = this.accountsWithInfo.findIndex(
                x => x.entity.id == deletedAccount.id
            );
            if (deletedIndex > -1)
                this.$delete(this.accountsWithInfo, deletedIndex);
                */
        },
        getProviderName(id) {
            var i = this.providers
                ? this.providers.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getAccountStatusName(id) {
            var i = this.accountStatuses
                ? this.accountStatuses.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getFundingTypeName(id) {
            var i = this.fundingTypes
                ? this.fundingTypes.find(x => x.key == id)
                : null;
            return i ? i.value : "";
        },
        dateToString(date) {
            return dateToString(date ? new Date(date) : null);
        },
        //patient find forms-------------------
        loadPatientFindForm() {
            this.patientFindFormKey += 1;
            this.patientFindFormVisible = true;
        },
        closePatientFindForm() {
            this.patientFindFormVisible = false;
        },
        clearPatientFindForm() {
            this.filterPatient = null;
            this.paginationDebounce(0);
        },
        locatedPatient(patient) {
            this.filterPatient = patient;
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
